// src/components/pages/ProfileEditPage.js

import React from "react";
import { Container } from "@mui/material";
import { useLocation } from "react-router-dom";
import ProfileForm from "../molecules/UserProfile/Edit/ProfileForm";

const ProfileEditPage = () => {
  // Read potential return target (e.g., /challenge/events/:id or /watch)
  const location = useLocation();
  const from =
    location.state?.from ||
    sessionStorage.getItem("returnToAfterAuth") ||
    null;

  return (
    <Container maxWidth="md">
      <ProfileForm returnTo={from} />
    </Container>
  );
};

export default ProfileEditPage;
